// extracted by mini-css-extract-plugin
module.exports = {"palette":"PaletteColorSelector_palette__LtO8a","item":"PaletteColorSelector_item__bDVO8","selected":"PaletteColorSelector_selected__zQPFh"};